var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20001 16C3.20001 8.94235 8.94241 3.19995 16 3.19995C23.0576 3.19995 28.8 8.94235 28.8 16C28.8 18.08 28.2896 20.1456 27.3232 21.9728C27.1168 22.3648 26.6336 22.5136 26.2416 22.3072C25.8512 22.1008 25.7008 21.6176 25.9088 21.2272C26.7536 19.6272 27.2 17.8208 27.2 16C27.2 9.82555 22.176 4.79995 16 4.79995C9.82401 4.79995 4.80001 9.82555 4.80001 16C4.80001 22.1744 9.82401 27.2 16 27.2C17.8224 27.2 19.6288 26.7535 21.2256 25.9072C21.6192 25.7008 22.1008 25.8512 22.3072 26.2416C22.5136 26.6336 22.3648 27.1152 21.9744 27.3232C20.1472 28.2896 18.0816 28.8 16 28.8C8.94241 28.8 3.20001 23.0576 3.20001 16ZM15.2 8.79995C15.2 8.35835 15.5584 7.99995 16 7.99995C16.4416 7.99995 16.8 8.35835 16.8 8.79995V15.6688L20.5664 19.4336C20.8784 19.7472 20.8784 20.2528 20.5664 20.5664C20.4096 20.7215 20.2048 20.8 20 20.8C19.7952 20.8 19.5904 20.7215 19.4336 20.5664L15.4336 16.5664C15.2848 16.416 15.2 16.2128 15.2 16V8.79995Z",
    fill: "#0072CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_594_11422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 26,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20001 16C3.20001 8.94235 8.94241 3.19995 16 3.19995C23.0576 3.19995 28.8 8.94235 28.8 16C28.8 18.08 28.2896 20.1456 27.3232 21.9728C27.1168 22.3648 26.6336 22.5136 26.2416 22.3072C25.8512 22.1008 25.7008 21.6176 25.9088 21.2272C26.7536 19.6272 27.2 17.8208 27.2 16C27.2 9.82555 22.176 4.79995 16 4.79995C9.82401 4.79995 4.80001 9.82555 4.80001 16C4.80001 22.1744 9.82401 27.2 16 27.2C17.8224 27.2 19.6288 26.7535 21.2256 25.9072C21.6192 25.7008 22.1008 25.8512 22.3072 26.2416C22.5136 26.6336 22.3648 27.1152 21.9744 27.3232C20.1472 28.2896 18.0816 28.8 16 28.8C8.94241 28.8 3.20001 23.0576 3.20001 16ZM15.2 8.79995C15.2 8.35835 15.5584 7.99995 16 7.99995C16.4416 7.99995 16.8 8.35835 16.8 8.79995V15.6688L20.5664 19.4336C20.8784 19.7472 20.8784 20.2528 20.5664 20.5664C20.4096 20.7215 20.2048 20.8 20 20.8C19.7952 20.8 19.5904 20.7215 19.4336 20.5664L15.4336 16.5664C15.2848 16.416 15.2 16.2128 15.2 16V8.79995Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_594_11422)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.305efb5e.svg";
export { ForwardRef as ReactComponent };